import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth0 } from '@auth0/auth0-react';

export const useWelcome = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [showErrorNotification, setShowErrorNotification] = useState(false);
  const { isAuthenticated, loginWithRedirect, error, isLoading } = useAuth0();

  useEffect(() => {
    const onWelcomePage =
      location.pathname === '/' || location.pathname === '/welcome';

    if (isAuthenticated && onWelcomePage) {
      navigate('/dashboard');
    }
  }, [isAuthenticated, navigate, location]);

  useEffect(() => {
    if (error) {
      console.error('Auth0 error:', error);
      setShowErrorNotification(true);
    }
  }, [error]);

  return {
    showErrorNotification,
    loginWithRedirect,
    isLoading,
    isAuthenticated,
    error
  };
};
